import { createContext, useState, type Dispatch, type SetStateAction, type ReactNode } from 'react';

export type LastAddedItem = {
  id?: string | number;
  type?: string;
  [key: string]: unknown;
} | null;

export interface LastAddedItemContextValue {
  lastAddedItem: LastAddedItem;
  setLastAddedItem: Dispatch<SetStateAction<LastAddedItem>>;
}

export const LastAddedItemContext = createContext<LastAddedItemContextValue>({} as LastAddedItemContextValue);

interface LastAddedItemContextProviderProps {
  children: ReactNode;
}

const LastAddedItemContextProvider = (props: LastAddedItemContextProviderProps) => {
  const [lastAddedItem, setLastAddedItem] = useState<LastAddedItem>(null);

  return (
    <LastAddedItemContext.Provider
      value={{
        lastAddedItem,
        setLastAddedItem,
      }}
    >
      {props.children}
    </LastAddedItemContext.Provider>
  );
};

export default LastAddedItemContextProvider;
